// React context for the admin client and the auth service.
import { createContext, useContext } from "react";
import type { AdminClient } from "../api/client";
import type { OpsDeviceClient } from "../api/ops";
import type { AuthService } from "../auth/auth";
import type { ConsoleConfig } from "../config";

export interface Services {
  api: AdminClient;
  auth: AuthService;
  config: ConsoleConfig;
  /** The ops device approval routes (ADR-0029). */
  ops: OpsDeviceClient;
}

export const ServicesContext = createContext<Services | null>(null);

/** Returns the console services. Must be inside ServicesContext. */
export function useServices(): Services {
  const s = useContext(ServicesContext);
  if (!s) throw new Error("ServicesContext is missing");
  return s;
}
